import { Component, OnInit } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { Sidebar } from './core/components/sidebar/sidebar';
import { Header } from './core/components/header/header';
import { RouterOutlet } from '@angular/router';
import { TelemetryService } from '@share/services/telemetry.service';
import { BlockPermissionsStore } from '@share/services/block-permissions.store';

@Component({
    selector: 'app-root',
    templateUrl: './app.html',
    styleUrl: './app.css',
    imports: [Sidebar, Header, RouterOutlet]
})
export class App implements OnInit {

  constructor(
    private calService: CalAngularService,
    private telemetryService: TelemetryService,
    private blockPermissionsStore: BlockPermissionsStore
  ) { }


  ngOnInit(): void {

    // Sign in the user on startup
    this.calService.isUserSignedIn().subscribe((isSignedIn) => {
      let user = this.calService.getAccount();

      if (isSignedIn) {
        this.telemetryService.logEvent('LoginEvent', {
          ObjectId: user?.localAccountId,
          Username: user?.username
        });

        console.log(`User: ${user.username} logged in.`);
        console.log(user);

        // Load global block permissions now that the user session is established
        this.blockPermissionsStore.load();
      }
    });
  }

}
